/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PopupDto } from '../../models/popup-dto';

export interface PopupControllerFindAll$Params {
}

export function popupControllerFindAll(http: HttpClient, rootUrl: string, params?: PopupControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PopupDto>>> {
  const rb = new RequestBuilder(rootUrl, popupControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PopupDto>>;
    })
  );
}

popupControllerFindAll.PATH = '/api/popup';
